import { gql } from '__generated__';

export default gql(`
  mutation FinalizeParticipantFieldImport($input: FinalizeParticipantFieldImportInput!) {
    finalizeParticipantFieldImport(input: $input) {
      id
      importing
      ready_to_import
      deletable
    }
  }
`);
